import {createClient} from '@supabase/supabase-js';
import {configureSupabaseAuth, type CmsSupabaseClient} from '@etlyn/etlyn-cms';

// Public project configuration; Supabase owns tokens and PKCE storage.
const projectURL = "https://nqsclqtpnosuhoobgyxc.supabase.co";
const publicKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5xc2NscXRwbm9zdWhvb2JneXhjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3NDQ1OTIsImV4cCI6MjA3NjMyMDU5Mn0.87-uj86yhuSKOuKc-jO8OYxlqHsdn1qAWbx_09VGmRM";
// The identity SDK needs an absolute API origin; tenant data may use a relative proxy.
const configuredApi = import.meta.env.VITE_API_URL?.trim() || '';
const authApiOrigin = /^https?:\/\//.test(configuredApi) ? configuredApi : 'https://server-411905.uc.r.appspot.com';
const mode = import.meta.env.VITE_AUTH_MODE?.trim() || (import.meta.env.PROD ? 'supabase' : 'legacy');
if (mode === 'supabase') {
  const client = createClient(import.meta.env.VITE_SUPABASE_URL || projectURL,
    import.meta.env.VITE_SUPABASE_ANON_KEY || publicKey,
    {auth: {flowType: 'pkce', autoRefreshToken: true, persistSession: true, detectSessionInUrl: false}});
  configureSupabaseAuth({client: client as unknown as CmsSupabaseClient,
    apiBaseUrl: authApiOrigin, googleOAuth: import.meta.env.VITE_GOOGLE_AUTH_ENABLED !== 'false'});
}
